import React from 'react';
import { Select } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useApplicationContext } from '@/context/v1/Application/context';
import { ORGANIZATION_FIELD } from './constants';
import { FieldFormItem } from './styles';

export function Organization(): JSX.Element {
	const { organization } = useApplicationContext();

	const options = [{ label: organization?.name, value: organization?.id }];

	return (
		<FieldFormItem name={ORGANIZATION_FIELD} label={I18n.get('Company')} labelCol={{ span: 24 }}>
			<Select disabled options={options} placeholder={I18n.get('Company')} />
		</FieldFormItem>
	);
}
